export class ScrChecker {
    constructor() {
        this.inviewElems = []; //inviewで効果をつける要素を登録する
    }
    setProps(el, props) {
        for (let key in props) {
            el.style.setProperty('--' + key, props[key]);
        }
    };
    clamp(v, min, max) {
        return min > v ? min : max < v ? max : v;
    }
    round(n) {
        return Math.round(n * 10000) / 10000;
    }

    calcElementOffsetY(elem) {
        let container = window;

        let parentElem;
        if (elem.parentElement) {
            parentElem = elem.parentElement;
        }
        let target = parentElem;

        // ページ全体に対するY座標を計算
        let numY = 0;
        do {
            numY += target.offsetTop; //target.offsetTop;はノードの上端に対しての現在の要素の距離
            target = target.offsetParent;
            //console.log(target);
        } while (target && target !== container); //要素のcontainerに対するY座標

        return numY;
    }


    onUpdate() {

        //ウインドウ情報 ie11未対応
        //let windowWidth = window.innerWidth;
        //let windowHeight = window.innerHeight;
        //let windowOffsetY = window.scrollY;

        //ウインドウ情報など ie11対応
        let windowLeft = (window.screenLeft || window.screenX || 0);
        let windowTop = (window.screenTop || window.screenY || 0);
        let windowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);
        let windowHeight = (window.innerHeight || document.documentElement.clientHeight || 0);
        let windowScrollY = window.scrollY || window.pageYOffset;
        let windowScrollX = window.scrollX || window.pageXOffset;


        //console.log(windowScrollY);
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];

        if (windowScrollY > windowHeight) {
            this.body.classList.add('scrolled-windowheight');
        } else {
            this.body.classList.remove('scrolled-windowheight');
        }

        if (windowScrollY > windowHeight * 0.8) {
            this.body.classList.add('scrolled-show-index-pager');
        } else {
            this.body.classList.remove('scrolled-show-index-pager');
        }

        if (this.body.classList.contains('index') || this.body.classList.contains('en')) {
            //this.body.classList.remove('scrolled-title');
        } else {
            if (windowScrollY > 200) {
                this.body.classList.add('scrolled-title');
            } else {
                this.body.classList.remove('scrolled-title');
            }
        }

        //recruit
        if(this.body.classList.contains('recruit') || this.body.classList.contains('recruit-child')){
            this.body.classList.add('scrolled-title');
        }




        // ===========
        // inview判定

        //.js-anim-inview に .inview 追加
        if (this.inviewElems.length !== 0) {
            //inviewElems = document.querySelectorAll('.js-anim-inview');//複数
            [].forEach.call(this.inviewElems, (elem) => {
                //console.log(elem.classList);
                let clientRect = elem.getBoundingClientRect(); // 要素の位置座標
                let y = clientRect.top; //画面の上端から、要素の上端までの距離
                //let elemY = window.pageYOffset + clientRect.top;// ページの上端から、要素の上端までの距離

                //表示タイミング ウインドウ上端から
                let showPos = windowHeight * 0.5;
                if (windowWidth > 600) {
                    showPos = windowHeight * 0.4; //pc
                }

                if (elem.classList.contains('fadein')) {
                    showPos = windowHeight * 0.8;
                }

                if (showPos > y) {
                    if (this.body.classList.contains('loaded')) {
                        elem.classList.add('inview');
                    } else {
                        elem.classList.add('inview');
                    }
                }
            });
        }


        // ===========
        // JSでの表示位置調整
        if (this.rotateHeadingElems !== 0) {
            [].forEach.call(this.rotateHeadingElems, (elem, index) => {
                let calcp, imageHeightView, skewHeight = 0;

                if (windowWidth > 735) {
                    //画像全体は1000:377.5
                    imageHeightView = windowWidth * (0.3775 - 0.16);
                    skewHeight = windowWidth * 0.16; //斜め線は1000:1600
                    calcp = 0.5 * (imageHeightView - elem.clientHeight) + 12;
                } else {
                    //画像全体は750:428 = 0.57066
                    imageHeightView = windowWidth * (0.57066 - 0.24);
                    skewHeight = windowWidth * 0.24; //斜め線は1000:240
                    calcp = 0.5 * (imageHeightView - elem.clientHeight) + 8;
                    if (index != 1) {
                        calcp = 0.5 * (imageHeightView - elem.clientHeight) + 6;
                    }
                }

                let props = {
                    'trans-y': calcp,
                }

                this.setProps(elem, props);
                //console.log(imageHeightView + ', titleH=' + elem.clientHeight);
            });
        }


        // ===========
        // SIDE PAGER 切り替え
        if (document.getElementById('index-side-pager')) {
            // 全体
            let sidePos = document.getElementById('index-side-pager');

            // 丸
            let bullets = sidePos.querySelectorAll('.line .bullet-container .bullet');

            // 切り替え基準
            let checkSectionsId = ['index-news', 'index-about', 'index-member', 'index-product', 'index-contact'];

            // 丸リセット
            let nowState = 0;
            [].forEach.call(bullets, (elem) => {
                elem.classList.remove('selected');
            });

            // 切り替え実行 1
            [].forEach.call(checkSectionsId, (id) => {
                let elem = document.getElementById(id);
                let clientRect = elem.getBoundingClientRect(); // 要素の位置座標
                let y = clientRect.top; //画面の上端から、要素の上端までの距離

                //切り替えタイミング ウインドウ上端から
                let showPos = windowHeight * 0.2;
                if (windowWidth > 600) {
                    showPos = windowHeight * 0.3; //pc
                }

                //何番目を表示するか
                if (y < showPos) {
                    nowState += 1;
                }
            });

            if (nowState == 0 || nowState == 2 || nowState == 3 || nowState == 4) {
                sidePos.classList.add('white');
            } else {
                sidePos.classList.remove('white');
            }

            // 丸 切り替え
            [].forEach.call(bullets, (elem, index) => {
                if ((nowState - 1) == index) {
                    elem.classList.add('selected');
                }
            });

        }



        // ===========
        // SIDE menu v2
        // 一定以上スクロールしてサイドバーが下端まできたら固定し、記事の最後まで来たらスクロールを再開
        // ただし「サイドバーより記事の方が高さがある」「サイドバーがウインドウサイズに収まる（極端に縦長のウインドウ）」場合はこの処理を行わない
        // # js-sidelist-scroll-or-fixu　.js-fixed
        if (document.getElementById('js-sidelist-scroll-or-fix')) {

            // 親
            let parentElement = document.getElementById('js-parent-sidelist-scroll-or-fix');
            let parentElementY = parentElement.getBoundingClientRect().top;
            let parentElementPageY = window.pageYOffset + parentElementY;

            // 記事
            let articleElement = parentElement.querySelectorAll('.article')[0];
            let articleElementHeight = articleElement.clientHeight;

            // サイドメニュー
            let sideElement = document.getElementById('js-sidelist-scroll-or-fix');
            let sideElementY = sideElement.getBoundingClientRect().top;
            let sideElementHeight = sideElement.clientHeight;

            // 上端時のサイドメニューの位置 + 高さ
            let scrollStopY = (window.pageYOffset + parentElementY) + sideElementHeight;

            // 親要素の下端
            let parentElementBottom = parentElement.querySelectorAll('.js-sidelist')[0];
            let parentElementBottomY = window.pageYOffset + parentElementY + parentElementBottom.clientHeight;

            //console.log('垂直方向のスクロール量=' + window.pageYOffset + ', 上端時のサイドメニューの位置+高さ=' + scrollStopY + ', 親要素の下端=' + parentElementBottomY);

            let sidePos = '';
            let sidePosFlg = 1; //スクロール追従切替を停止などするかどうか、 0=しない、1=上下とも制限、2=上下とも制限する(条件B)



            if (sideElementHeight > articleElementHeight) {
                // 条件A.記事の方がサイドバーより高さがある/スクロール追従切替を停止
                sidePosFlg = 0;
                console.log('条件A.記事の方がサイドバーより高さがある/スクロール追従切替しない');
            } else {
                // 条件B.サイドバーがウインドウサイズに収まる
                if (windowHeight > (sideElementHeight + 90)) {
                    sidePosFlg = 2;
                    console.log('条件B.サイドバーがウインドウサイズに収まる/スクロール追従切替する windowH=' + windowHeight + ', sideH=' + sideElementHeight);
                } else {
                    sidePosFlg = 1;
                    console.log('条件C.サイドバーがウインドウサイズに収まらない/スクロール追従切替する windowH=' + windowHeight + ', sideH=' + sideElementHeight);
                }

            }

            // 実行 上下とも制限
            if (sidePosFlg == 1) {
                //console.log((window.pageYOffset + windowHeight), (parentElementPageY + sideElementHeight));
                //一定以上スクロール1(サイドメニューをウインドウ下端で止める)
                if ((parentElementPageY + sideElementHeight) <= (window.pageYOffset + windowHeight)) {
                    sidePos = 'fixed-bottom';
                    //さらに一定以上スクロール2(記事の下端で止める)
                    if ((window.pageYOffset + windowHeight - 0) >= parentElementBottomY) {
                        sidePos = 'bottom';
                    }
                } else {
                    //sidePos = 'top';
                }
            }
            // if (sidePosFlg == 1) {
            //     //一定以上スクロール1(上で止める)
            //     if ((scrollStopY + 40) <= (window.pageYOffset + windowHeight)) {
            //         sidePos = 'fixed';
            //         //さらに一定以上スクロール2(下で止める)
            //         if ((window.pageYOffset + windowHeight) >= parentElementBottomY) {
            //             sidePos = 'bottom';
            //         }
            //     } else {
            //         sidePos = 'top';
            //     }
            // }

            // 実行 上下とも制限(条件B サイドバーがウインドウサイズに収まる)
            if (sidePosFlg == 2) {
                //一定以上スクロール1(上で止める)
                if (parentElementY <= 90) {
                    sidePos = 'fixed-top';
                    //さらに一定以上スクロール2(下で止める)
                    let checkY = window.pageYOffset + windowHeight - (windowHeight - sideElementHeight - 40 - 50); // .article-rowの下マージン、.submenu-containerの下マージン
                    if (checkY >= parentElementBottomY) {
                        sidePos = 'bottom';
                    }
                } else {
                    sidePos = 'top';
                }
            }

            //css指定
            sideElement.classList.remove('js-top');
            sideElement.classList.remove('js-fixed');
            sideElement.classList.remove('js-fixed-top');
            sideElement.classList.remove('js-fixed-bottom');
            sideElement.classList.remove('js-bottom');
            if (sidePos !== '') {
                sideElement.classList.add('js-' + sidePos);
            }

        }

    } //onUpdate()



    // 初期化
    init() {
        this.inviewElems = document.querySelectorAll('.js-anim-inview'); //複数
        this.rotateHeadingElems = document.querySelectorAll('.js-pos-on-skewimg'); //複数
        //this.parallaxSections = document.querySelectorAll('.parallax-section');
    }
}